export const DEFAULT_PASS_THRESHOLD = 80;

export const STAT_THRESHOLDS = {
  DANGER: 50,
  WARNING: 75,
};

export const PIN_MIN_LENGTH = 5;
export const PIN_MAX_LENGTH = 8;

export const COPY_FEEDBACK_MS = 2000;

export const EMBED_IFRAME_HEIGHT = 700;

export const DEFAULT_SORT_ORDER = 999;

export const RETRY_TRANSITION_MS = 1800;
